<template>
    <div class="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
                <form
                    v-if="eventAttendee.status !== 'canceled'"
                    class="space-y-6"
                    action="#"
                    method="POST"
                >
                    <div class="grid grid-cols-3 gap-4">
                        <div class="font-bold">Scheduled by</div>
                        <div class="col-span-2">{{ eventAttendee.email }}</div>

                        <div class="font-bold">Organized by</div>
                        <div class="col-span-2">
                            {{ eventAttendee.organizer }}
                        </div>

                        <div class="font-bold">Start</div>
                        <div class="col-span-2">
                            {{ eventAttendee.start_date }}
                        </div>

                        <div class="font-bold">End</div>
                        <div class="col-span-2">
                            {{ eventAttendee.end_date }}
                        </div>

                        <div
                            v-if="eventAttendee.googleMeetLink"
                            class="font-bold"
                        >
                            Meet link
                        </div>
                        <div
                            v-if="eventAttendee.googleMeetLink"
                            class="col-span-2"
                        >
                            {{ eventAttendee.googleMeetLink }}
                        </div>
                    </div>

                    <div>
                        <a
                            :href="downloadLink"
                            target="_blank"
                            class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Download
                        </a>
                        <button
                            class="mt-3 flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            @click.prevent="cancel"
                        >
                            Cancel
                        </button>
                    </div>
                </form>

                <div v-else class="flex items-center justify-center space-y-6">
                    <h1 class="text-xl font-semibold">Already canceled</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import axios from "axios";

const props = defineProps({
    eventAttendee: {
        type: Object,
        required: true,
    },
    cancelLink: {
        type: String,
        required: true,
    },
    downloadLink: {
        type: String,
        required: true,
    },
});

const cancel = () => {
    if (!confirm("Do you really want to cancel this event?")) {
        return;
    }

    axios.post(props.cancelLink).then(() => {
        window.location.reload();
    });
};
</script>
